<template>
  <div>
    <m-dropdown
      label="Take payment from"
      v-model="selection"
      :items="selections"
      data-test="account-selection"
    ></m-dropdown>
  </div>
</template>

<script>

const accountSelections = [
  'All Accumulation Accounts',
  'All Pension Accounts',
  'Specific Accounts',
];

export default {
  name: 'account-selection',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selections: accountSelections,
      selection: '',
    };
  },
  watch: {
    value: {
      handler(value) {
        this.selection = value;
      },
      immediate: true,
    },
    selection(value) {
      this.$emit('input', value);
    },
  },
};
</script>
